import { render, staticRenderFns } from "./BkkLayer.vue?vue&type=template&id=607971fd&"
import script from "./BkkLayer.vue?vue&type=script&lang=js&"
export * from "./BkkLayer.vue?vue&type=script&lang=js&"
import style0 from "./BkkLayer.vue?vue&type=style&index=0&id=607971fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports